// eslint-disable-next-line no-shadow
export enum MyActionsSelectedStatus {
    AWAITING_ACTION = 97,
}
// used to exclude actions in MyActionsGrid and exclude filters in FilterPanel
// ManAuth is Discretionary Pay
export const MOBILE_EXCLUDED_REQUEST_TYPES = ['Absence', 'Wfm Absence', 'Late', 'ManAuth']
